module.exports = __webpack_public_path__ + "static/media/21ECLAC26.faa824bc.jpg";